import React, { useState } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";

const NavBarAuth = () => {
  const navigate = useNavigate();
  const [nav, setNav] = useState(false);

  const links = [
    { id: 1, link: "About Us", to: 'about' },
    { id: 2, link: "Services", to: 'services' },
    { id: 3, link: "Pricing", to: 'pricing' },
    { id: 4, link: "Level", to: 'level' },
    { id: 5, link: "Contact Us", to: 'contact' },
  ];


  return (

    <div className="flex justify-between items-center w-full h-20 px-4 text-black bg-white ">
      <div className=" max-h-8">
        <Link to="/">
          <h1 className="ml-2 oxygen-bold text-3xl animate__animated animate__backInLeft animate__slow cursor-pointer">paycott.</h1>
        </Link>
      </div>



      <div className="hidden xl:flex">
        <button onClick={() => navigate("/signin")} className="m-1 bg-transparent hover:bg-green-500 text-black-700 font-semibold hover:text-white py-2 px-4 border border-black-500 hover:border-transparent rounded-full w-32 animate__animated animate__fadeInDown animate__delay-1s">
          LogIn
        </button>
        <button onClick={() => navigate("/signup")} className="m-1 bg-green-500 hover:bg-transparent  hover:bg-white-500 font-semibold hover:text-black py-2 px-4 border border-black-500 hover:border-green-500 rounded-full w-32 text-white animate__animated animate__fadeInDown animate__delay-1s">
          SignUp
        </button>
      </div>

      <div
        onClick={() => setNav(!nav)}
        className="cursor-pointer pr-4 z-40 text-black xl:hidden"
      >
        <FaBars size={30} />

      </div>
      {nav && (
        <div className="flex flex-col xl:hidden fixed bg-[#fafafa] w-[100%] h-[100%] top-0 bottom-0 left-0 right-0 z-50">
          <div className="text-black self-end text-3xl mt-4 mr-4" onClick={() => { setNav(false) }}>
            <FaTimes size={30} className="text-black" />
          </div>
          <ul className="flex flex-col gap-6 my-8 font-pop font-normal self-center">
            {links.map((link) => (
              <Link
                to={link.to}
                key={link.id}
                onClick={() => { setNav(false) }}
                className="cursor-pointer capitalize text-2xl z-40"
              >
                {link.link}
              </Link>
            ))}
          </ul>
          <div className="flex xl:hidden self-center gap-2 font-pop">
            <button onClick={() => navigate("/signin")} className="m-1 bg-white border-2 border-light hover:bg-primarygreen text-black font-semibold hover:text-white py-2 px-8 text-2xl font-pop rounded-full ease-in-out duration-300">
              LogIn
            </button>
            <button onClick={() => navigate("/signup")} className="m-1 bg-primarygreen hover:bg-transparent font-pop text-2xl border-2 border-primarygreen font-semibold hover:text-primarygreen py-2 px-8 rounded-full ease-in-out duration-300">
              SignUp
            </button>
          </div>
        </div>
      )}

    </div>


  );
};

export default NavBarAuth;
